module.exports = __webpack_public_path__ + "static/chains-b127abcd016ff9a4b6b7c8d648e1d674.webp";